import React, { Fragment } from "react";
import { themeStyle, themeStyleDark } from "./Components";
import { useSelector } from "react-redux";
import { Grid } from "@mui/material";
import Button from "@mui/material/Button";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PhoneInTalkIcon from "@mui/icons-material/PhoneInTalk";
import CopyrightIcon from "@mui/icons-material/Copyright";
import { Up } from "./PositionFade";
import { UpInView } from "./PositionFadeInView";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default function Footer(props) {
  const state = useSelector((state) => state);
  const timelineDelays = [0, 600, 1200, 1800, 2400];
  const timelineDelays2 = [100, 200, 300, 400, 500];
  const timelineDelays3 = [700, 800, 900];

  const timelineDelays4 = [1300, 1400, 1500];
  const timelineDelays5 = [1900];
  const navigate = useNavigate();

  return (
    <div
      className="footer anigrad"
      style={{ backgroundColor: "white", maxWidth: "100vw" }}
    >
      <div
        style={{
          minHeight: "60vh",
          width: "100vw",
          padding: "100px 0px 100px 25px",
        }}
      >
        <Grid container>
          <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
          <Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
            <Grid container spacing={5}>
              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <UpInView delay={timelineDelays[0]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    Riches Media Digital
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 6vh 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                ></div>
                <UpInView delay={timelineDelays2[0]}>
                  <Link
                    to="/about-us/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    About Us
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[1]}>
                  <Link
                    to="/contact-us/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Contact Us
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[2]}>
                  <Link
                    to="/careers/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Careers
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/blog/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Blog
                  </Link>
                </UpInView>
              </Grid>

              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                  marginLeft: !state.auth.isMobile ? "-75px" : 0,
                  marginRight: !state.auth.isMobile ? "75px" : 0,
                }}
              >
                <UpInView delay={timelineDelays[0]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    Services
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 6vh 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                ></div>
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/digital-marketing/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Digital Marketing
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/programmatic-advertising/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Programmatic Advertising
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/search-engine-optimization/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Search Engine Optimization
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/web-design/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Web Design
                  </Link>
                </UpInView>
                <br />
              </Grid>

              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <UpInView delay={timelineDelays[0]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    Quick Links
                  </div>
                </UpInView>
                <div
                  style={{
                    margin: "15px 0px 6vh 0px",
                    width: "30px",
                    height: "3px",
                    backgroundColor: themeStyle.primaryColor,
                  }}
                ></div>
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/sitemap/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Sitemap
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/terms-of-service/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Terms of Service
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/privacy-policy/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Privacy Policy
                  </Link>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays2[3]}>
                  <Link
                    to="/compliance/"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      textDecoration: "none",
                    }}
                  >
                    Compliance
                  </Link>
                </UpInView>
              </Grid>

              <Grid
                item
                md={3}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                {" "}
                <UpInView delay={timelineDelays[2]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    USA
                  </div>
                </UpInView>
                <UpInView delay={timelineDelays4[0]}>
                  <div
                    style={{
                      marginTop: "15px",
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    301 NJ-17, Rutherford, NJ 07070, United States{" "}
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays4[1]}>
                  <a
                    href="tel:+12014562171"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <PhoneInTalkIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    +1 201 456 2171
                  </a>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays3[2]}>
                  <a
                    href="mailto:letstalk@richesmediadigital.com"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <EmailIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    letstalk@richesmediadigital.com
                  </a>
                </UpInView>
                <br />
                <br />
                <br />
                <UpInView delay={timelineDelays[1]}>
                  <div
                    style={{
                      fontSize: "22px",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    India
                  </div>
                </UpInView>
                <UpInView delay={timelineDelays3[0]}>
                  <div
                    style={{
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      marginTop: "15px",
                      alignItems: "center",
                    }}
                  >
                    <LocationOnIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    3, A V Square, Block No.7, BEML Layout, Mysuru, Karnataka
                    570023
                  </div>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays3[1]}>
                  <a
                    href="tel:+918214240111"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <PhoneInTalkIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    +91 8214240111
                  </a>
                </UpInView>
                <br />
                <UpInView delay={timelineDelays3[2]}>
                  <a
                    href="mailto:letstalk@richesmediadigital.com"
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8vh",
                      color: "white",
                      display: "flex",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <EmailIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                        marginRight: "15px",
                      }}
                    />{" "}
                    letstalk@richesmediadigital.com
                  </a>
                </UpInView>
                <br />
              </Grid>
            </Grid>
            <br />
            <br />
            <br />

            <Grid
              container
              spacing={5}
              justifyContent="space-between"
              alignItems={"center"}
            >
              <Grid
                item
                md={4}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    fontSize: "1.8vh",
                    color: "white",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <CopyrightIcon
                    style={{
                      color: "white",
                      fontSize: "22px",
                      marginRight: "15px",
                    }}
                  />{" "}
                  2026, Riches Media Digital
                </div>
              </Grid>
              <Grid
                item
                md={4}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    borderRadius: "25px",
                    width: "100%",
                    height: "6vh",
                    fontSize: "26px",
                    color: "white",
                    fontWeight: "bold",
                    marginTop: "10px",
                  }}
                >
                  Riches Media Digital
                </div>
              </Grid>
              <Grid
                item
                md={4}
                sm={12}
                xs={12}
                style={{
                  height: "100%",
                  width: "100%",
                  textAlign: "left",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: state.auth.isMobile
                      ? "flex-start"
                      : "flex-end",
                  }}
                >
                  <a
                    href="https://in.linkedin.com/company/richesmediadigital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "6vh",
                      height: "6vh",
                      fontSize: "1.8vh",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <LinkedInIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                      }}
                    />
                  </a>

                  <a
                    href="https://www.facebook.com/Richesmediadigital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "6vh",
                      height: "6vh",
                      fontSize: "1.8vh",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <FacebookIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                      }}
                    />
                  </a>
                  <a
                    href="https://www.instagram.com/richesmediadigital/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      border: "1px white solid",
                      borderRadius: "40px",
                      width: "6vh",
                      height: "6vh",
                      fontSize: "1.8vh",
                      color: "white",
                      marginRight: "15px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textDecoration: "none",
                    }}
                  >
                    <InstagramIcon
                      style={{
                        color: "white",
                        fontSize: "22px",
                      }}
                    />
                  </a>
                </div>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={0} sm={0} md={1} lg={1} xl={1}></Grid>
        </Grid>
      </div>
    </div>
  );
}
